import React, { useState } from 'react';
import { PlusCircle, AlertTriangle, ChevronDown, ChevronRight } from 'lucide-react';

export const Toast = ({ message, type, onClose }) => {
  if (!message) return null;
  const bgColor = type === 'success' ? 'bg-green-500' : type === 'error' ? 'bg-red-500' : type === 'warning' ? 'bg-yellow-500' : 'bg-blue-500';
  const typeText = type === 'success' ? 'Başarılı' : type === 'error' ? 'Hata' : type === 'warning' ? 'Uyarı' : 'Bilgi';
  return (
    <div className={`fixed bottom-4 right-4 p-4 rounded-lg shadow-xl text-white ${bgColor} z-50 transition-all duration-300 ease-in-out ${message ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'}`} style={{ maxWidth: '400px' }}>
      <div className="flex items-start">
        <div className="flex-shrink-0 pt-0.5">
          {type === 'success' && <PlusCircle className="h-5 w-5" />}
          {type === 'error' && <AlertTriangle className="h-5 w-5" />}
          {type === 'warning' && <AlertTriangle className="h-5 w-5" />}
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm font-medium">{typeText}</p>
          <p className="text-sm mt-1">{message}</p>
        </div>
        <div className="ml-4 flex-shrink-0 flex">
          <button onClick={onClose} className="inline-flex text-white rounded-md hover:bg-white hover:bg-opacity-20 p-1 focus:outline-none focus:ring-2 focus:ring-white">
            <span className="sr-only">Kapat</span>
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export const Modal = ({ isOpen, onClose, title, children, size = "md" }) => {
  if (!isOpen) return null;
  const sizeClasses = { sm: "max-w-sm", md: "max-w-md", lg: "max-w-lg", xl: "max-w-xl", "2xl": "max-w-2xl" };
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40 p-4 overflow-y-auto">
      <div className={`bg-white p-6 rounded-lg shadow-xl w-full ${sizeClasses[size]} my-8 transform transition-all duration-300 ease-out ${isOpen ? "scale-100 opacity-100" : "scale-95 opacity-0"}`}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">{title}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">×</button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const ConfirmationModal = ({ isOpen, onClose, title, message, onConfirm, confirmText = "Evet", cancelText = "Hayır" }) => {
  if (!isOpen) return null;
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <p className="text-gray-700 mb-6">{message}</p>
      <div className="flex justify-end space-x-3">
        <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">{cancelText}</button>
        <button onClick={() => { onConfirm(); onClose(); }} className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700">{confirmText}</button>
      </div>
    </Modal>
  );
};

export const NavItem = ({ icon, label, viewName, currentView, setCurrentView, subItems, isSubItem = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isActive = currentView === viewName || (subItems && subItems.some(sub => sub.viewName === currentView));
  const handleNav = (e, name) => {
    e.preventDefault();
    if (subItems) setIsOpen(!isOpen);
    else setCurrentView(name);
  };
  const itemClass = `flex items-center p-3 rounded-lg hover:bg-sky-600 transition-colors ${isActive ? 'bg-sky-700 font-semibold' : ''} ${isSubItem ? 'pl-6 text-sm' : 'text-base'}`;

  return (
    <li className="mb-1">
      <a href="#" onClick={(e) => handleNav(e, viewName)} className={itemClass}>
        {icon} <span className="ml-3 flex-1">{label}</span> {subItems && (isOpen ? <ChevronDown size={18} className="ml-auto" /> : <ChevronRight size={18} className="ml-auto" />)}
      </a>
      {subItems && isOpen &&
        <ul className="mt-1 border-l-2 border-sky-500 ml-3 pl-3">
          {subItems.map(sub => <NavItem key={sub.viewName} {...sub} currentView={currentView} setCurrentView={setCurrentView} isSubItem={true} />)}
        </ul>
      }
    </li>
  );
};